// Hardcoded application routes - same for all organizations
export const APP_ROUTES = {
  home: "/",
  signin: "/signin",
  account: "/account",
  admin: "/admin"
} as const;

// App configuration type definition
export interface AppConfig {
  branding: {
    name: string;
    fullName: string;
    tagline: string;
    logo: {
      src: string;
      alt: string;
      dimensions: {
        height: string;
        width: string;
      };
    };
  };
  meta: {
    themeColor: string;
    defaultDescription: string;
    favicon: {
      ico: string;
      png16: string;
      png32: string;
      appleTouchIcon: string;
    };
  };
  email: {
    syncErrorSubject: string;
  };
}

// NFC Configuration
export const nfcConfig: AppConfig = {
  branding: {
    name: "NFC",
    fullName: "NFC Admin",
    tagline: "Admin",
    logo: {
      src: "/images/nfc-logo-square.png",
      alt: "Logo",
      dimensions: {
        height: "52px",
        width: "48px"
      }
    }
  },
  meta: {
    themeColor: "#FFFFFF",
    defaultDescription: "Welcome to NFC Admin",
    favicon: {
      ico: "/favicon.ico",
      png16: "/favicon-16x16.png",
      png32: "/favicon-32x32.png",
      appleTouchIcon: "/apple-touch-icon.png"
    }
  },
  email: {
    syncErrorSubject: "NFC Admin Sync Error"
  }
};

// NGE Configuration
export const ngeConfig: AppConfig = {
  branding: {
    name: "NGE",
    fullName: "NGE Admin",
    tagline: "Admin",
    logo: {
      src: "/images/nge-logo-square.png",
      alt: "NGE Logo",
      dimensions: {
        height: "52px",
        width: "52px"
      }
    }
  },
  meta: {
    themeColor: "#FFFFFF",
    defaultDescription: "Welcome to NGE Admin",
    favicon: {
      ico: "/nge-favicon.ico",
      png16: "/nge-favicon-16x16.png",
      png32: "/nge-favicon-32x32.png",
      appleTouchIcon: "/nge-apple-touch-icon.png"
    }
  },
  email: {
    syncErrorSubject: "NGE Admin Sync Error"
  }
};
